var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 33.6663C26.2048 33.6663 33.6667 26.2044 33.6667 16.9997C33.6667 7.79493 26.2048 0.333008 17 0.333008C7.79526 0.333008 0.333344 7.79493 0.333344 16.9997C0.333344 26.2044 7.79526 33.6663 17 33.6663ZM14.8225 23.4094L22.6895 18.7646C23.9924 17.9954 23.9924 16.004 22.6895 15.2347L14.8225 10.59C13.5562 9.84236 12 10.8155 12 12.3549V21.6444C12 23.1839 13.5562 24.157 14.8225 23.4094Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/playButton.636a962d.svg";
export { SvgComponent as ReactComponent };